<template>
  <div>
    <div class='career-stats-title'>
      <div>{{ $t("playerCareerStats.years") }}</div>
      <div>{{ $t("playerSeasonStats.team") }}</div>
      <div>{{ $t("playerSeasonStats.gamePlayed") }}</div>
      <div>{{ $t("playerSeasonStats.rebounds") }}</div>
      <div>{{ $t("playerSeasonStats.assists") }}</div>
      <div>{{ $t("playerSeasonStats.steals") }}</div>
      <div>{{ $t("playerSeasonStats.blockShots") }}</div>
      <div>{{ $t("playerSeasonStats.points") }}</div>
    </div>
    <hr/>
  </div>
</template>

<script>
export default {
  name: 'career-stats-title'
}
</script>

<style lang="sass" scoped>
@import '../styles'

.career-stats-title
  @extend %titleRow
  display: flex

  div:nth-child(1)
    width: vw(44)
    text-align: initial

  div:nth-child(2)
    width: vw(46)
    text-align: initial

  div:nth-child(n+3)
    width: vw(38)
</style>
